import { useEffect, useState } from "react";
import type { RoundListItem } from "../../../shared/contracts/product-pages.js";
import type { RoundSnapshot } from "../../../domain/round/round-types.js";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "../../shell/approved-icons.js";
import { ClubhouseNextRound } from "./clubhouse-approved-cards.js";
import { latestUnseenResult } from "./clubhouse-result-state.js";
import { activityScore } from "./clubhouse-activity-model.js";

export function ClubhouseNextAction(props: {
  accountId: string;
  round: RoundSnapshot | null;
  followed: boolean;
  queued: boolean;
  rounds: RoundListItem[];
  onOpen(): void;
  onResult(round: RoundListItem): void;
}): React.JSX.Element {
  const [, refresh] = useState(0);
  useEffect(() => {
    const update = () => refresh((value) => value + 1);
    window.addEventListener("fairway-result-seen", update);
    window.addEventListener("storage", update);
    return () => {
      window.removeEventListener("fairway-result-seen", update);
      window.removeEventListener("storage", update);
    };
  }, []);
  const review = props.rounds.find(
    (round) => round.state === "disputed" || round.mainResult?.reviewStatus,
  );
  const result = review ?? latestUnseenResult(props.rounds, props.accountId);
  if (props.round || props.queued || !result)
    return (
      <ClubhouseNextRound
        round={props.round}
        followed={props.followed}
        onOpen={props.onOpen}
      />
    );
  const score = activityScore(result);
  return (
    <section className="fr-home-next">
      <div className="fr-home-next-caption">
        <span>{review ? "RESULT TO REVIEW" : "YOUR LATEST RESULT"}</span>
      </div>
      <Button
        variant="gold-gradient"
        size="block"
        onClick={() => {
          props.onResult(result);
        }}
      >
        {review ? "Review result" : `See result · ${score.value}`}
        <ArrowRight data-icon="inline-end" />
      </Button>
      <p>
        {result.courseName} · {score.label}
      </p>
    </section>
  );
}
